import PropTypes from "prop-types";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button } from "@material-ui/core";
import useStyles from "../../pages/Resume/styles";

export default function AbilityCard({ item, onClick }) {
  const classes = useStyles();
  const { description, level } = item;

  function translate(lvl) {
    if (lvl === "ADVANCED") {
      return "Avançado";
    }
    if (lvl === "INTERMEDIATE") {
      return "Intermediário";
    }
    if (lvl === "BASIC") {
      return "Básico";
    }
    if (lvl === "FLUENT") {
      return "Fluente";
    }
    return "";
  }

  return (
    <div className={classes.card}>
      <div>
        <h4>{description}</h4>
        <p>{translate(level)}</p>
      </div>
      <Button className={classes.delete} type="button" onClick={onClick}>
        <DeleteIcon />
      </Button>
    </div>
  );
}

AbilityCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    description: PropTypes.string.isRequired,
    level: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};
